module.exports = __webpack_public_path__ + "static/media/icon-announcements.775cd2c4.svg";